import React from 'react'
import {Link} from 'react-router-dom'
import './footer.css'
const Footer = () => {
  return (
    <div className='footer'>
      <h6 className='text-center'>
        All Right Reserved &copy; MAR Online Store 2023
      </h6>
      <p className='text-center mt-2'>
        <Link to='/about'>About</Link>
        |
        <Link to='/policy'>Privacy Policy</Link>
        |
        <Link to='/contact'>Contact Us</Link>
      </p>
    </div>
  )
}

export default Footer
